<template>
	<nk-wrapper spacing="md">
		<nk-filter-ratsinfosystem-sitzungen :options="options" :context="{}" />
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'TemplateFilterRatsinfosystem',

	mixins: [TemplatesDefault],
};
</script>
